//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models


        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The cart meta info model
* 
* @param affiliateId The source affiliate id (af)
* @param affiliateSid The source affiliate sid (saf)
* @param templateId The source template id
*/
@Serializable

data class CartMetaInfo (


      /* The source affiliate id (af) */
    @SerialName(value = "affiliateId") val affiliateId: kotlin.String? = null,


      /* The source affiliate sid (saf) */
    @SerialName(value = "affiliateSid") val affiliateSid: kotlin.String? = null,


      /* The source template id */
    @SerialName(value = "templateId") val templateId: kotlin.uuid.Uuid? = null


) {




  }

